import { ApplicationModuleTypes } from "../../globals";
import { SpecialLayoutNames } from "../../interfaces/enums";
import { IWorkspaceLayout } from "../../interfaces/Workspace";

export const FactoryPresetLayouts = new Array<IWorkspaceLayout>(
	{
		name: SpecialLayoutNames.DefaultWorkspace,
		showInMenu: true,
		layout: {
			"dockbox": {
				"id": "+22",
				"size": 280,
				"mode": "horizontal",
				"children": [
					{
						"id": "leftDock",
						"size": 369,
						"mode": "vertical",
						"children": [
							{
								"id": "topLeft",
								"size": 200,
								"tabs": [
									{
										"id": ApplicationModuleTypes.StepHierarchy
									},
									{
										"id": ApplicationModuleTypes.ARTrackers
									}
								],
								"activeId": ApplicationModuleTypes.StepHierarchy
							},
							{
								"id": "bottomLeft",
								"size": 200,
								"tabs": [
									{
										"id": ApplicationModuleTypes.AssetLibrary
									},
									{
										"id": ApplicationModuleTypes.StepActions
									}
								],
								"activeId": ApplicationModuleTypes.AssetLibrary
							}
						]
					},
					{
						"id": "centerPlusRightDock",
						"size": 1163,
						"mode": "vertical",
						"children": [
							{
								"id": "topPlusCenterPlusRight",
								"size": 280,
								"mode": "horizontal",
								"children": [
									{
										"id": "topCenterDock",
										"size": 855,
										"tabs": [
											{
												"id": ApplicationModuleTypes.SceneView
											},
											{
												"id": ApplicationModuleTypes.VisageEditorWindow
											},
										],
										"activeId": ApplicationModuleTypes.SceneView
									},
									{
										"id": "rightDock",
										"size": 382,
										"tabs": [
											{
												"id": ApplicationModuleTypes.ObjectProperties
											},
											{
												"id": ApplicationModuleTypes.UIEditor
											},
											{
												"id": ApplicationModuleTypes.ChecklistEditor
											},
											{
												"id": ApplicationModuleTypes.PartsCatalogEditor
											},
										],
										"activeId": ApplicationModuleTypes.ObjectProperties
									}
								]
							},
							{
								"id": "bottomDock",
								"size": 120,
								"tabs": [
									{
										"id": ApplicationModuleTypes.TimelineEditor
									}
								],
								"activeId": ApplicationModuleTypes.TimelineEditor
							}
						]
					}
				]
			},
			"floatbox": {
				"id": "+23",
				"size": 200,
				"mode": "float",
				"children": []
			},
			"windowbox": {
				"id": "+24",
				"size": 1,
				"mode": "window",
				"children": []
			},
			"maxbox": {
				"id": "+25",
				"size": 1,
				"mode": "maximize",
				"children": []
			}
		}
	},
	{
		name: SpecialLayoutNames.TimelineEditingWorkspace,
		showInMenu: true,
		layout: {
			"dockbox": {
				"id": "+22",
				"size": 280,
				"mode": "horizontal",
				"children": [
					{
						"id": "bottomLeft",
						"size": 285,
						"tabs": [
							{
								"id": ApplicationModuleTypes.StepHierarchy
							},
						],
						"activeId": ApplicationModuleTypes.StepHierarchy
					},
					{
						"id": "bottomDock",
						"size": 927,
						"tabs": [
							{
								"id": ApplicationModuleTypes.TimelineEditor
							},
						],
						"activeId": ApplicationModuleTypes.TimelineEditor
					},
					{
						"id": "+61",
						"size": 316,
						"mode": "vertical",
						"children": [
							{
								"id": "+60",
								"size": 211,
								"tabs": [
									{
										"id": ApplicationModuleTypes.SceneView
									},
								],
								"activeId": ApplicationModuleTypes.SceneView
							},
							{
								"id": "+30",
								"size": 385,
								"tabs": [
									{
										"id": ApplicationModuleTypes.ObjectProperties
									},
									{
										"id": ApplicationModuleTypes.ObjectGroups
									},
									{
										"id": ApplicationModuleTypes.UIEditor
									},
									{
										"id": ApplicationModuleTypes.ActionHistory
									},
								],
								"activeId": ApplicationModuleTypes.ObjectProperties
							}
						]
					}
				]
			},
			"floatbox": {
				"id": "+23",
				"size": 200,
				"mode": "float",
				"children": []
			},
			"windowbox": {
				"id": "+24",
				"size": 1,
				"mode": "window",
				"children": []
			},
			"maxbox": {
				"id": "+25",
				"size": 1,
				"mode": "maximize",
				"children": []
			}
		}
	},
	{
		name: SpecialLayoutNames.MultiViewWorkspace,
		showInMenu: true,
		layout: {
			"dockbox": {
				"id": "+22",
				"size": 280,
				"mode": "horizontal",
				"children": [
					{
						"id": "leftDock",
						"size": 369,
						"mode": "vertical",
						"children": [
							{
								"id": "bottomLeft",
								"size": 200,
								"tabs": [
									{
										"id": ApplicationModuleTypes.StepHierarchy
									},
									{
										"id": ApplicationModuleTypes.ARTrackers
									}
								],
								"activeId": ApplicationModuleTypes.StepHierarchy
							},
							{
								"id": "topLeft",
								"size": 200,
								"tabs": [
									{
										"id": ApplicationModuleTypes.AssetLibrary
									}
								],
								"activeId": ApplicationModuleTypes.AssetLibrary
							}
						]
					},
					{
						"id": "centerPlusRightDock",
						"size": 1163,
						"mode": "vertical",
						"children": [
							{
								"id": "topPlusCenterPlusRight",
								"size": 280,
								"mode": "horizontal",
								"children": [
									{
										"id": "topCenterDock",
										"size": 427.5,
										"tabs": [
											{
												"id": ApplicationModuleTypes.SceneView
											}
										],
										"activeId": ApplicationModuleTypes.SceneView
									},
									{
										"id": "+27",
										"size": 427.5,
										"tabs": [
											{
												"id": "SceneView2"
											}
										],
										"activeId": "SceneView2"
									},
									{
										"id": "rightDock",
										"size": 382,
										"tabs": [
											{
												"id": ApplicationModuleTypes.ObjectProperties
											},
											{
												"id": ApplicationModuleTypes.UIEditor
											},
											{
												"id": ApplicationModuleTypes.ChecklistEditor
											},
										],
										"activeId": ApplicationModuleTypes.ObjectProperties
									}
								]
							},
							{
								"id": "bottomDock",
								"size": 120,
								"tabs": [
									{
										"id": ApplicationModuleTypes.TimelineEditor
									}
								],
								"activeId": ApplicationModuleTypes.TimelineEditor
							}
						]
					}
				]
			},
			"floatbox": {
				"id": "+23",
				"size": 200,
				"mode": "float",
				"children": []
			},
			"windowbox": {
				"id": "+24",
				"size": 1,
				"mode": "window",
				"children": []
			},
			"maxbox": {
				"id": "+25",
				"size": 1,
				"mode": "maximize",
				"children": []
			}
		}
	},
	{
		name: SpecialLayoutNames.AllWindowsWorkspace,
		showInMenu: true,
		layout: {
			"dockbox": {
				"id": "+106",
				"size": 280,
				"mode": "vertical",
				"children": [
					{
						"id": "+22",
						"size": 472,
						"mode": "horizontal",
						"children": [
							{
								"id": "bottomLeft",
								"size": 400,
								"tabs": [
									{
										"id": ApplicationModuleTypes.StepHierarchy
									},
									{
										"id": ApplicationModuleTypes.ARTrackers
									},
									{
										"id": ApplicationModuleTypes.RevisionsEditor
									}
								],
								"activeId": ApplicationModuleTypes.StepHierarchy
							},
							{
								"id": "topCenterDock",
								"size": 637.2277992277993,
								"tabs": [
									{
										"id": ApplicationModuleTypes.SceneView
									},
									{
										"id": ApplicationModuleTypes.SequenceEditor
									}
								],
								"activeId": ApplicationModuleTypes.SceneView
							},
							{
								"id": "rightDock",
								"size": 400.7722007722008,
								"tabs": [
									{
										"id": ApplicationModuleTypes.ObjectProperties
									},
									{
										"id": ApplicationModuleTypes.ObjectGroups
									},
									{
										"id": ApplicationModuleTypes.UIEditor
									},
									{
										"id": ApplicationModuleTypes.ChecklistEditor
									},
									{
										"id": ApplicationModuleTypes.ActionHistory
									},
								],
								"activeId": ApplicationModuleTypes.ObjectProperties
							}
						]
					},
					{
						"id": "+107",
						"size": 150,
						"tabs": [
							{
								"id": ApplicationModuleTypes.AssetLibrary
							},
							{
								"id": ApplicationModuleTypes.TimelineEditor
							}
						],
						"activeId": ApplicationModuleTypes.TimelineEditor
					}
				]
			},
			"floatbox": {
				"id": "+23",
				"size": 200,
				"mode": "float",
				"children": []
			},
			"windowbox": {
				"id": "+24",
				"size": 1,
				"mode": "window",
				"children": []
			},
			"maxbox": {
				"id": "+25",
				"size": 1,
				"mode": "maximize",
				"children": []
			}
		}
	},
	{
		name: SpecialLayoutNames.DefaultStep,
		showInMenu: false,
		layout: {
			"dockbox": {
				"id": "+22",
				"size": 280,
				"mode": "horizontal",
				"children": [
					{
						"id": "leftDock",
						"size": 349,
						"mode": "vertical",
						"children": [
							{
								"id": "bottomLeft",
								"size": 364,
								"tabs": [
									{
										"id": ApplicationModuleTypes.StepHierarchy,
									}
								],
								"activeId": ApplicationModuleTypes.StepHierarchy
							},
							{
								"id": "topLeft",
								"size": 220,
								"tabs": [
									{
										"id": ApplicationModuleTypes.AssetLibrary
									}
								],
								"activeId": ApplicationModuleTypes.AssetLibrary
							}
						]
					},
					{
						"id": "topCenterDock",
						"size": 797,
						"tabs": [
							{
								"id": ApplicationModuleTypes.SceneView
							}
						],
						"activeId": ApplicationModuleTypes.SceneView
					},
					{
						"id": "rightDock",
						"size": 382,
						"tabs": [
							{
								"id": ApplicationModuleTypes.ObjectProperties
							}
						],
						"activeId": ApplicationModuleTypes.ObjectProperties
					}
				]
			},
			"floatbox": {
				"id": "+23",
				"size": 200,
				"mode": "float",
				"children": []
			},
			"windowbox": {
				"id": "+24",
				"size": 1,
				"mode": "window",
				"children": []
			},
			"maxbox": {
				"id": "+25",
				"size": 1,
				"mode": "maximize",
				"children": []
			}
		}
	},
	{
		name: SpecialLayoutNames.ContentPlacementStep,
		showInMenu: false,
		layout: {
			"dockbox": {
				"id": "+22",
				"size": 280,
				"mode": "horizontal",
				"children": [
					{
						"id": "leftDock",
						"size": 349,
						"mode": "vertical",
						"children": [
							{
								"id": "bottomLeft",
								"size": 364,
								"tabs": [
									{
										"id": ApplicationModuleTypes.StepHierarchy
									}
								],
								"activeId": ApplicationModuleTypes.StepHierarchy
							},
							{
								"id": "topLeft",
								"size": 220,
								"tabs": [
									{
										"id": ApplicationModuleTypes.AssetLibrary
									}
								],
								"activeId": ApplicationModuleTypes.AssetLibrary
							}
						]
					},
					{
						"id": "+28",
						"size": 797,
						"mode": "vertical",
						"children": [
							{
								"id": "topCenterDock",
								"size": 437,
								"tabs": [
									{
										"id": ApplicationModuleTypes.SceneView
									}
								],
								"activeId": ApplicationModuleTypes.SceneView
							},
							{
								"id": "+29",
								"size": 147,
								"tabs": [
									{
										"id": ApplicationModuleTypes.ARTrackers
									}
								],
								"activeId": ApplicationModuleTypes.ARTrackers
							}
						]
					},
					{
						"id": "rightDock",
						"size": 382,
						"tabs": [
							{
								"id": ApplicationModuleTypes.ObjectProperties
							},
							{
								"id": ApplicationModuleTypes.UIEditor
							}
						],
						"activeId": ApplicationModuleTypes.ObjectProperties
					}
				]
			},
			"floatbox": {
				"id": "+23",
				"size": 200,
				"mode": "float",
				"children": []
			},
			"windowbox": {
				"id": "+24",
				"size": 1,
				"mode": "window",
				"children": []
			},
			"maxbox": {
				"id": "+25",
				"size": 1,
				"mode": "maximize",
				"children": []
			}
		}

	},
	{
		name: SpecialLayoutNames.SlideEditing,
		showInMenu: false,
		layout: {
			"dockbox": {
				"id": "+22",
				"size": 280,
				"mode": "horizontal",
				"children": [
					{
						"id": "topLeft",
						"size": 473,
						"tabs": [
							{
								"id": ApplicationModuleTypes.AssetLibrary
							}
						],
						"activeId": ApplicationModuleTypes.AssetLibrary
					},
					{
						"id": "topCenterDock",
						"size": 964,
						"tabs": [
							{
								"id": ApplicationModuleTypes.SceneView
							}
						],
						"activeId": ApplicationModuleTypes.SceneView
					}
				]
			},
			"floatbox": {
				"id": "+23",
				"size": 200,
				"mode": "float",
				"children": []
			},
			"windowbox": {
				"id": "+24",
				"size": 1,
				"mode": "window",
				"children": []
			},
			"maxbox": {
				"id": "+25",
				"size": 1,
				"mode": "maximize",
				"children": []
			}
		}
	},
	{
		name: SpecialLayoutNames.Simulation,
		showInMenu: false,
		layout: {
			"dockbox": {
				"id": "centerPlusRightDock",
				"size": 1085,
				"mode": "vertical",
				"children": [
					{
						"id": "topCenterDock",
						"size": 280,
						"tabs": [
							{
								"id": ApplicationModuleTypes.SceneView
							}
						],
						"activeId": ApplicationModuleTypes.SceneView
					},
				]
			},
			"floatbox": {
				"id": "+23",
				"size": 200,
				"mode": "float",
				"children": []
			},
			"windowbox": {
				"id": "+24",
				"size": 1,
				"mode": "window",
				"children": []
			},
			"maxbox": {
				"id": "+25",
				"size": 1,
				"mode": "maximize",
				"children": []
			}
		}
	},
	{
		name: SpecialLayoutNames.SimulationTrackers,
		showInMenu: false,
		layout: {
			"dockbox": {
				"id": "centerPlusRightDock",
				"size": 1085,
				"mode": "vertical",
				"children": [
					{
						"id": "topCenterDock",
						"size": 280,
						"tabs": [
							{
								"id": ApplicationModuleTypes.SceneView
							}
						],
						"activeId": ApplicationModuleTypes.SceneView
					}
				]
			},
			"floatbox": {
				"id": "+23",
				"size": 200,
				"mode": "float",
				"children": []
			},
			"windowbox": {
				"id": "+24",
				"size": 1,
				"mode": "window",
				"children": []
			},
			"maxbox": {
				"id": "+25",
				"size": 1,
				"mode": "maximize",
				"children": []
			}
		}
	},
	{
		name: SpecialLayoutNames.ViewOnly,
		showInMenu: false,
		layout: {
			"dockbox": {
				"id": "centerPlusRightDock",
				"size": 1085,
				"mode": "vertical",
				"children": [
					{
						"id": "topCenterDock",
						"size": 280,
						"tabs": [
							{
								"id": ApplicationModuleTypes.SceneView
							}
						],
						"activeId": ApplicationModuleTypes.SceneView
					},
				]
			},
			"floatbox": {
				"id": "+23",
				"size": 200,
				"mode": "float",
				"children": []
			},
			"windowbox": {
				"id": "+24",
				"size": 1,
				"mode": "window",
				"children": []
			},
			"maxbox": {
				"id": "+25",
				"size": 1,
				"mode": "maximize",
				"children": []
			}
		}
	},
);